"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLoaderTextProp = exports.StyledLoaderDefault = exports.StyledLoaderWrapper = void 0;
var styled_components_1 = require("styled-components");
var polished_1 = require("polished");
var theme_1 = require("../../utils/theme");
var types_1 = require("../../utils/types");
exports.StyledLoaderWrapper = styled_components_1.default.div({
    alignItems: 'center',
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%'
});
var getLoaderDefaultStyles = function (_a) {
    var _b;
    var loaderSize = _a.loaderSize, theme = _a.theme;
    var defaultLoaderSizes = {
        lg: {
            borderWidth: 3,
            dimensions: 34 // 40px minus border width * 2
        },
        sm: {
            borderWidth: 2,
            dimensions: 16 // 18px minus border width * 2
        }
    };
    var loaderDefaultColors = (_b = {},
        _b[types_1.LIGHT] = {
            color: theme_1.colors.green1
        },
        _b[types_1.DARK] = {
            color: theme_1.colors.white
        },
        _b);
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: ", "px solid\n      ", ";\n    border-top: ", "px solid\n      ", ";\n    width: ", "px;\n    height: ", "px;\n  "], ["\n    border: ", "px solid\n      ",
        ";\n    border-top: ", "px solid\n      ", ";\n    width: ", "px;\n    height: ", "px;\n  "])), defaultLoaderSizes[loaderSize].borderWidth, polished_1.rgba(loaderDefaultColors[theme].color
        ? loaderDefaultColors[theme].color
        : '', 0.2), defaultLoaderSizes[loaderSize].borderWidth, loaderDefaultColors[theme].color, defaultLoaderSizes[loaderSize].dimensions, defaultLoaderSizes[loaderSize].dimensions);
};
var DefaultLoaderRotate = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
exports.StyledLoaderDefault = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation: ", " 0.6s linear infinite;\n  border-radius: 50%;\n  display: inline-flex;\n  ", "\n"], ["\n  animation: ", " 0.6s linear infinite;\n  border-radius: 50%;\n  display: inline-flex;\n  ",
    "\n"])), DefaultLoaderRotate, function (props) {
    return getLoaderDefaultStyles({
        loaderSize: props.loaderSize,
        theme: props.theme
    });
});
exports.StyledLoaderTextProp = styled_components_1.default.div({
    marginTop: theme_1.scaffolding.md,
    width: '100%'
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map